import { ElCase } from '@element-plus/components/case'
import { ElAffixBottom } from '@element-plus/components/affix-bottom'
import { ElTablePage } from '@element-plus/components/table-page'
import { ElTableDialog } from '@element-plus/components/table-dialog'
import { ElEditable } from '@element-plus/components/editable'
import { ElReadMore } from '@element-plus/components/read-more'
import { ElDraggableTable } from '@element-plus/components/draggable-table'
import { ElTextEllipsis } from '@element-plus/components/text-ellipsis'
import { ElEditor, ElEditorToolbar } from '@element-plus/components/editor'
import { ElEllipsis } from '@element-plus/components/ellipsis'
import { ElArrayItems } from '@element-plus/components/array-items'
import {
  ElArrayTable,
  ElArrayTableColumn,
} from '@element-plus/components/array-table'
import { ElBubble, ElBubbleList } from '@element-plus/components/bubble'
import { ElFlex } from '@element-plus/components/flex'
import { ElSubmit } from '@element-plus/components/submit'
import { ElReset } from '@element-plus/components/reset'
import { ElDialogV2 } from '@element-plus/components/dialog-v2'
import { ElDrawerV2 } from '@element-plus/components/drawer-v2'
import {
  ElEmoji,
  ElEmoticon,
  ElFontEmoticon,
} from '@element-plus/components/emoji'
import { ElVirtualList } from '@element-plus/components/virtual-list'
import { ElDot } from '@element-plus/components/dot'
import { ElTextHighlight } from '@element-plus/components/text-highlight'
import { ElContextmenu } from '@element-plus/components/contextmenu'
import { ElPreviewFile } from '@element-plus/components/preview-file'
import { ElRenderer } from '@element-plus/components/renderer'
import { ElSelectV3 } from '@element-plus/components/select-v3'
import {
  ElDropdownV2,
  ElDropdownV2Panel,
} from '@element-plus/components/dropdown-v2'
import { ElLoadMore } from '@element-plus/components/load-more'
import { ElSortableList } from '@element-plus/components/sortable-list'
import { ElList } from '@element-plus/components/list'
import { ElFullScreen } from '@element-plus/components/full-screen'
import { ElSplit } from '@element-plus/components/split'
import { ElQrCode } from '@element-plus/components/qr-code'
import { ElConfigProviderV2 } from '@element-plus/components/config-provider-v2'
import { ElVideo } from '@element-plus/components/video'
import { ElVideoViewer } from '@element-plus/components/video-viewer'
import { ElPlainTabs } from '@element-plus/components/plain-tabs'
import { ElLineTree } from '@element-plus/components/line-tree'
import { ElResizable } from '@element-plus/components/resizable'
import { ElCollapsePanel } from '@element-plus/components/collapse-panel'
import {
  ElTabsSelect,
  ElTabsSelectPanel,
} from '@element-plus/components/tabs-select'

import type { Plugin } from 'vue'

export default [
  ElCase,
  ElAffixBottom,
  ElTablePage,
  ElTableDialog,
  ElEditable,
  ElReadMore,
  ElDraggableTable,
  ElTextEllipsis,
  ElEditor,
  ElEllipsis,
  ElArrayItems,
  ElArrayTable,
  ElArrayTableColumn,
  ElBubble,
  ElBubbleList,
  ElFlex,
  ElSubmit,
  ElReset,
  ElDialogV2,
  ElDrawerV2,
  ElEmoji,
  ElEmoticon,
  ElFontEmoticon,
  ElEditorToolbar,
  ElVirtualList,
  ElDot,
  ElTextHighlight,
  ElContextmenu,
  ElPreviewFile,
  ElRenderer,
  ElSelectV3,
  ElDropdownV2,
  ElDropdownV2Panel,
  ElLoadMore,
  ElSortableList,
  ElList,
  ElFullScreen,
  ElSplit,
  ElQrCode,
  ElConfigProviderV2,
  ElVideo,
  ElVideoViewer,
  ElPlainTabs,
  ElLineTree,
  ElResizable,
  ElCollapsePanel,
  ElTabsSelect,
  ElTabsSelectPanel,
] as Plugin[]
